/**
 * 接口域名的管理
 */

const base = {
  sq: (process.env.VUE_APP_API_URL || '').split('.').map((str, index) => index !== 1 ? str : (window.location.hostname.split('.')[1] || str)).join('.'),
  qs: process.env.VUE_APP_H5_URL,
  info: process.env.VUE_APP_INFO_URL,
  trade: process.env.VUE_APP_YUNCLOUD_URL,
  origin: (process.env.VUE_APP_HEADER_ORIGIN || '').split('.').map((str, index) => index !== 1 ? str : (window.location.hostname.split('.')[1] || str)).join('.'),
  // qs: '/api',
};

export default base;
